<template>
	<Card v-if="activities.length > 0" :title="trans(`events.activities.${pack.type}.title`)" :subtitle="pack.selection_type === 'multiple' ? transChoice('events.activities.selection_limit.multiple', pack.selection_limit) : trans('events.activities.selection_limit.simple')">
		<template v-for="activity in activities" :key="`enrollment-activity-${activity.id}`">
			<div v-if="activity.mandatory" class="input-like">
				<i class="fa-solid fa-check text-green-700"/>
				<p class="grow">{{ activity.title }}</p>
				<p class="text-gray-400">{{ trans('events.activities.mandatory') }}</p>
			</div>
			<div v-else :key="`activity-${activity.id}-${selectedActivitiesIds.includes(activity.id) ? 'on' : 'off'}`" class="input-like flex items-center gap-2 cursor-pointer select-none" @click.stop="update(activity)">
				<i v-if="selectedActivitiesIds.includes(activity.id)" class="fa-solid fa-toggle-on text-green-600"/>
				<i v-else class="fa-solid fa-toggle-off text-red-600"/>
				<p class="grow whitespace-normal">{{ activity.title }}</p>
				<p class="text-gray-400 whitespace-nowrap">{{ transChoice('events.activities.available', activity.available) }}</p>
			</div>
		</template>
	</Card>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {ref, type Ref, defineProps} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import {trans, transChoice} from 'laravel-vue-i18n'
import {type Pack} from '@/Types/Events/Packs/Pack'
import {type Enrollment} from '@/Types/Events/Enrollment'
import {type Activity} from '@/Types/Events/Packs/Activities/Activity'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	pack:Pack,
	activities:Array<Activity>,
	enrollment:Array<Enrollment>,
	selectedActivitiesIds:Array<number>,
}>()

const pack:Ref<Pack> = ref(props.pack)
const working:Ref<boolean> = ref(false)
const enrollment:Ref<Enrollment> = ref(props.enrollment)
const activities:Ref<Array<Activity>> = ref(props.activities)
const selectedActivitiesIds:Ref<Array<number>> = ref(props.selectedActivitiesIds)

function update(activity:Activity):void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.post(route('events.enrollments.activities.update', {
			event: pack.value.event_id,
			enrollment: enrollment.value.id,
			activity: activity.id,
		})).then(({data}:{data:{activities:Array<Activity>, selectedActivitiesIds:Array<number>}}) => {
			showSuccess(trans('general.updated'))
			activities.value = data.activities
			selectedActivitiesIds.value = data.selectedActivitiesIds
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>